import { z } from "zod";

// svc-04 email-settings form (rule §D.9 — AWS SES, no SMTP host/port).
// `replyToEmail` and `testRecipient` are nullable on the wire; the form
// uses empty strings and the page maps "" → null on save.
export const smtpSchema = z.object({
  enabled: z.boolean(),
  fromEmail: z.string().email("Enter a valid email address"),
  fromName: z.string().min(1, "From name is required"),
  replyToEmail: z.string().email("Enter a valid email").or(z.literal("")).optional(),
  testRecipient: z.string().email("Enter a valid email").or(z.literal("")).optional(),
  // No transport fields: email is delivered by the fixed internal
  // outbound-emailer (retired the admin-configurable relay 2026-07-01).
});

export type SmtpFormData = z.infer<typeof smtpSchema>;
